import {
    mdiChartBar,
    mdiPlusThick,
    mdiCurrencyEur,
    mdiGift,
    mdiDatabaseSync,
    mdiTrophyVariant,
    mdiPackageVariantClosed,
    mdiTagMultiple,
    mdiCog
} from "@mdi/js";

import isEmpty from "lodash/isEmpty";
import {  mapActions } from "vuex";

export default {
    computed: {
        navLinks() {
            const { permissions,storePermissions, superUser } = this.$store.state
            const hideNewTransaction = this.$store.state.storePanel.store.flags ?this.$store.state.storePanel.store.flags
                .reward.offline_transaction : null;
            
                let links = []
                if (!isEmpty(permissions) && !isEmpty(storePermissions) || superUser) {
                    links =  [
                    {
                        title: {
                            el: "ΧΡΗΣΗ",
                            en: "USE",
                            it: "USO"
                        },
                        children: [
                            {
                                icon: mdiChartBar,
                                title: {
                                    el: "Αρχική",
                                    en: "Home",
                                    it: "Iniziale"
                                },
                                to: `/${this.lang}/storePanel`,
                                exact: true,
                                hide: this.hideTitle('homepage.read')
                            },
                            {
                                icon: mdiPlusThick,
                                title: {
                                    el: "Νέα Συναλλαγή",
                                    en: "New Transaction",
                                    it: "Nuova Transazione"
                                },
                                to: `/${this.lang}/storePanel/new-transaction`,
                                hide: this.hideTitle('transactions.create') ||
                                    !hideNewTransaction
                            },
                            {
                                icon: mdiCurrencyEur,
                                title: {
                                    el: "Συναλλαγές",
                                    en: "Transactions",
                                    it: "Transazione"
                                },
                                to: `/${this.lang}/storePanel/transactions?page=1`,
                                hide: this.hideTitle('transactions.read')
                            },
                            {
                                icon: mdiGift,
                                title: {
                                    el: "Εξαργύρωση",
                                    en: "Redeem",
                                    it: "Riscatta"
                                },
                                to: `/${this.lang}/storePanel/redeem`,
                                hide: this.hideTitle('redemption.read') 
                            },
                            {
                                icon: mdiDatabaseSync,
                                title: {
                                    el: "Ιστορικό",
                                    en: "History",
                                    it: "Cronologia"
                                },
                                to: `/${this.lang}/storePanel/history`,
                                hide: this.hideTitle('history.read') 
                            },
                            // {
                            //     icon: mdiTrophyVariant,
                            //     title: {
                            //         el: "Διαγωνισμοί",
                            //         en: "Contests",
                            //         it: "Concorsi"
                            //     },
                            //     to: `/${this.lang}/storePanel/contests`,
                            //     hide: superUser || storePermissions.contests.read && permissions.contests && permissions.contests.read ? false : true
                            // }
                        ]
                    },
                    {
                        title: { el: "ΡΥΘΜΙΣΕΙΣ", en: "SETTINGS", it: "IMPOSTAZIONI" },
                        children: [
                            {
                                icon: mdiPackageVariantClosed,
                                title: {
                                    el: "Προϊόντα",
                                    en: "Products",
                                    it: "Proddoti"
                                },
                                to: `/${this.lang}/storePanel/products`,
                                hide: this.hideTitle('products.read') 
                            },
                            {
                                icon: mdiTagMultiple,
                                title: {
                                    el: "Κουπόνια",
                                    en: "Coupons",
                                    it: "Tagliandi"
                                },
                                to: `/${this.lang}/storePanel/coupons`,
                                hide: this.hideTitle('coupons.read')
                            },
                            {
                                icon: mdiCog,
                                title: {
                                    el: "Ρυθμίσεις",
                                    en: "Settings",
                                    it: "Impostazioni"
                                },
                                to: `/${this.lang}/storePanel/settings`,
                                hide: this.hideTitle('settings.read') 
                            }
                        ]
                    }
                ];
            }
            return links
            
        }
    },
    methods: {
        ...mapActions(["getPermission"]),
        hideTitle(permission){
            return !(this.getPermission(permission))
        }
        
    },
 
};
